/* Bagsandlove – Set-Auswahl „1 Tasche / 2 Taschen“ (optional 3. Stufe, z. B. „3 Stück“).
   - Umschalten der Karten, „Tasche 2“ / „Tasche 3“-Reihen ein-/ausblenden
   - Überschrift der Farbauswahl darüber: „Farbe“ ↔ „Tasche 1“ (Wort kommt aus data-row-label)
   - Warenkorb-Button: ab 2 Stück Beschriftung ändern und alle Stück in den Warenkorb legen
   Der Set-Rabatt kommt NICHT von hier, sondern von automatischen Rabatten in Shopify. */
if (!customElements.get('bl-bundle')) {
  customElements.define(
    'bl-bundle',
    class BlBundle extends HTMLElement {
      connectedCallback() {
        this.qty = 1;
        this.units = this.dataset.units || 'Taschen';
        this.rowLabel = this.dataset.rowLabel || 'Tasche';
        this.info = this.closest('product-info') || document;
        this.addEventListener('click', (event) => {
          const opt = event.target.closest('.bl-bd__opt');
          if (opt) this.setQty(Number(opt.dataset.qty));
          // Empfehlungs-Leiste bei 1 Stück („Tipp: Nimm 2 …“) wählt direkt 2 Stück
          const tip = event.target.closest('[data-goto]');
          if (tip) this.setQty(Number(tip.dataset.goto));
        });

        // Tasche 2 / 3: Auswahl der Kacheln (jede Reihe für sich)
        this.rows = [...this.info.querySelectorAll('[data-bl-bundle-second]')];
        this.rows.forEach((row) => {
          row.addEventListener('click', (event) => {
            const swatch = event.target.closest('.bl-swatch');
            if (!swatch || swatch.disabled) return;
            row.querySelectorAll('.bl-swatch').forEach((s) => s.setAttribute('aria-checked', String(s === swatch)));
            const value = row.querySelector('[data-bl-second-value]');
            if (value) value.textContent = swatch.dataset.label;
          });
        });

        // Warenkorb-Button abfangen, wenn mehr als 1 Stück gewählt ist
        this.onAddClick = this.onAddClick.bind(this);
        document.addEventListener('click', this.onAddClick, true);

        // Das Theme setzt die Button-Beschriftung bei jedem Farbwechsel zurück – dann erneut anpassen
        this.observer = new MutationObserver(() => this.updateButton());
        this.observer.observe(this.info, { childList: true, subtree: true, characterData: true });

        // Vorauswahl aus dem Snippet (default_qty), z. B. „2 Stück“ beim Herz-Taschenhalter
        const initial = Number(this.dataset.defaultQty || 1);
        if (initial > 1) this.setQty(initial);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onAddClick, true);
        this.observer?.disconnect();
      }

      // Warenkorb-Einschub öffnen wie bei 1 Tasche: eigener Einschub (bl-cart), sonst App „Essential Cart“, sonst Warenkorbseite
      async openCart() {
        if (window.blCart) {
          try {
            await window.blCart.refresh({ open: true, pop: true });
            return;
          } catch (error) {
            console.warn('bl-bundle: Warenkorb-Einschub ließ sich nicht öffnen', error);
          }
        }
        const api = window.essentialCartApi;
        if (api?.openCart) {
          try {
            await api.refreshCart?.();
            api.openCart();
            return;
          } catch (error) {
            console.warn('bl-bundle: Warenkorb-Einschub ließ sich nicht öffnen', error);
          }
        }
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      }

      get addButton() {
        return this.info.querySelector('product-form [name="add"]');
      }

      setQty(qty) {
        this.qty = qty;
        this.querySelectorAll('.bl-bd__opt').forEach((o) => o.setAttribute('aria-checked', String(Number(o.dataset.qty) === qty)));
        this.rows.forEach((row) => (row.hidden = Number(row.dataset.row || 2) > qty));
        this.querySelectorAll('[data-note-for]').forEach((n) => (n.hidden = Number(n.dataset.noteFor) !== qty));
        const label = this.info.querySelector('bl-swatches [data-bl-swatch-label]');
        if (label) label.textContent = qty > 1 ? `${this.rowLabel} 1` : label.dataset.default || 'Farbe';
        this.updateButton();
      }

      updateButton() {
        const button = this.addButton;
        const span = button?.querySelector('span');
        if (!span || button.disabled) return;
        if (!this.defaultText) this.defaultText = span.textContent.trim();
        const wanted = this.qty > 1 ? `${this.qty} ${this.units} in den Warenkorb` : this.defaultText;
        if (span.textContent.trim() !== wanted) span.textContent = wanted;
      }

      async onAddClick(event) {
        if (this.qty < 2) return;
        const button = event.target.closest('product-form [name="add"]');
        if (!button || !this.info.contains(button)) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        const ids = [this.info.querySelector('product-form input[name="id"]')?.value];
        this.rows
          .filter((row) => Number(row.dataset.row || 2) <= this.qty)
          .forEach((row) => ids.push(row.querySelector('.bl-swatch[aria-checked="true"]')?.dataset.variantId));
        if (ids.length !== this.qty || ids.some((id) => !id)) return;
        // gleiche Farbe mehrfach → eine Zeile mit höherer Menge
        const counts = new Map();
        ids.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
        const items = [...counts].map(([id, quantity]) => ({ id: Number(id), quantity }));

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error((await res.json()).description || 'Fehler beim Hinzufügen');
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
          this.openCart();
        } catch (error) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
          alert(error.message);
        }
      }
    }
  );
}
